const ACTIONS = {
  GET_DONATION: "getDonation",
  CANCEL_DONATION: "cancelDonation",
  GET_DONATION_PARTNERS: "getDonationPartners",
  GET_ALL_SUBSCRIPTION: "getAllSubscription"
};

export { ACTIONS };